import { lazy } from 'react'

export const AllSetVariant1 = lazy(() => import('./AllSetVariant1'))
